import React from 'react';
import NotificationCenter from './NotificationCenter';
import RuntimeStatusBar from './RuntimeStatusBar';

type Props = {
  showRuntime: boolean;
};

/** Desktop app header — source health (compact) and notification bell in one row. */
export default function AppTopBar({ showRuntime }: Props) {
  return (
    <header className="layout-app-header" data-testid="layout-app-header">
      <div className="layout-app-header__actions">
        {showRuntime ? <RuntimeStatusBar compact /> : null}
        <NotificationCenter />
      </div>
    </header>
  );
}
